import React from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React context
import { useMaterialUIController } from "context";

const SCORE_FIELDS = [
  { name: "sleepScore", label: "Sleep" },
  { name: "foodScore", label: "Food" },
  { name: "moodScore", label: "Mood" },
  { name: "activityScore", label: "Activity" },
];

function BehaviouralCard({ no, behavioural }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <MDBox
      component="li"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      bgColor={darkMode ? "transparent" : "grey-100"}
      borderRadius="lg"
      p={4}
      m={0}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={2}>
          <MDTypography variant="subtitle1" fontWeight="medium">
            {no}
          </MDTypography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <MDTypography variant="subtitle2" color="text">
            {behavioural.date ? new Date(behavioural.date).toLocaleDateString() : "—"}
          </MDTypography>
        </Grid>
        {SCORE_FIELDS.map(({ name, label }) => (
          <Grid item xs={6} sm={1.75} key={name}>
            <MDTypography variant="caption" color="text" sx={{ display: "block" }}>
              {label}
            </MDTypography>
            <MDTypography variant="subtitle1" fontWeight="medium">
              {behavioural[name] ?? "—"}
            </MDTypography>
          </Grid>
        ))}
      </Grid>
    </MDBox>
  );
}

export default BehaviouralCard;
